/* eslint-disable prettier/prettier */
import axios from 'axios';
import getCookie from './getCookies'; // Import the getCookie function to retrieve CSRF token

// Set CSRF token header globally for axios using cookie retrieved by getCookie
axios.defaults.headers.common['X-CSRFToken'] = getCookie('csrftoken');

var Promise = require('promise');

const baseURL = process.env.REACT_APP_API_URL;

// Axios instance without authentication for endpoints that don't require login
const axiosAnonymousInstance = axios.create({
    baseURL: baseURL,
    timeout: 120000, // 2 min timeout
    headers: {
        'Content-Type': 'application/json',
        accept: 'application/json'
    }
});
// Handle 502 for anonymous requests
axiosAnonymousInstance.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && error.response.status === 502) {
            alert('502 Bad Gateway. Please try again later.');
        }
        return Promise.reject(error);
    }
);
// Axios instance with authentication for endpoints requiring JWT token
const axiosInstance = axios.create({
    baseURL: baseURL,
    timeout: 120000,
    headers: {
        Authorization: localStorage.getItem('access_token') ? 'JWT ' + localStorage.getItem('access_token') : null,
        'Content-Type': 'application/json',
        accept: 'application/json'
    }
});

// ✅ Inject token dynamically before each request to avoid stale/null token issues
axiosInstance.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('access_token');
        if (token) {
            config.headers['Authorization'] = 'JWT ' + token;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

// Axios response interceptor to handle automatic token refresh and error management
axiosInstance.interceptors.response.use(
    (response) => {
        // Simply return the response if successful
        return response;
    },
    async function (error) {
        const originalRequest = error.config;

        // Handle network/CORS errors gracefully
        // ✅ Handle network/CORS or completely missing response
        // if (typeof error?.response === 'undefined') {
        //     console.error('Network error or CORS issue:', error);
        //     alert('Network error or server error.'); // 👈 normal alert
        //     return Promise.reject({
        //         ...error,
        //         message: 'Network error.'
        //     });
        // }
        // if (typeof error.response === 'undefined') {
        //     // alert(
        //     //     'A server/network error occurred. ' +
        //     //         'Looks like CORS might be the problem. ' +
        //     //         'Sorry about this - we will get it fixed shortly.' +
        //     //         error
        //     // );
        //     return Promise.reject(error);
        // }

        if (error.response.status === 401 && originalRequest.url === baseURL + '/api/token/refresh/') {
            window.location.href = '/login/';
            return Promise.reject(error);
        }

        if (
            error.response.data.code === 'token_not_valid' &&
            error.response.status === 401 &&
            error.response.statusText === 'Unauthorized'
        ) {
            const refreshToken = localStorage.getItem('refresh_token');

            if (refreshToken) {
                // Decode refresh token payload to get expiration time
                const tokenParts = JSON.parse(atob(refreshToken.split('.')[1]));

                // exp date in token is expressed in seconds, while now() returns milliseconds:
                const now = Math.ceil(Date.now() / 1000);

                if (tokenParts.exp > now) {
                    // If refresh token is still valid, attempt to get a new access token
                    return axiosAnonymousInstance
                        .post('/api/token/refresh/', {
                            refresh: refreshToken
                        })
                        .then((response) => {
                            // Store new access token in local storage
                            localStorage.setItem('access_token', response.data.access);
                            // Update default headers for future requests
                            axiosInstance.defaults.headers['Authorization'] = 'JWT ' + response.data.access;

                            // Retry the original failed request with new access token
                            return axiosInstance({
                                ...originalRequest,
                                headers: {
                                    ...originalRequest.headers,
                                    Authorization: `JWT ${response.data.access}`
                                }
                            });
                        })
                        .catch((err) => {
                            if (err.response?.data?.code === 'token_not_valid' && err.response.status === 401) {
                                localStorage.removeItem('access_token');
                                localStorage.removeItem('refresh_token');
                                localStorage.removeItem( 'change_password' );
                                window.location.href = '/login/';
                                return Promise.reject(err);
                            }
                        });
                } else {
                    localStorage.removeItem('access_token');
                    localStorage.removeItem('refresh_token');
                    localStorage.removeItem( 'change_password' );
                    window.location.href = '/login';
                }
            } else {
                window.location.href = '/login';
            }
        }

        if (error.response.status === 400 && error.response.data?.detail === 'account Validity are expire.') {
            window.location.href = '/plan-validity/';
        }
        if (error.response.status === 400 && error.response.data?.detail === "you don't have permission to.") {
            window.location.href = '/access-denied/';
        }
        // ✅ 500 error handling
        if (error.response.status === 500) {
            console.error('Internal Server Error:', error.response);
            // Optionally, add UI feedback logic here
            window.location.href = '/internal-server-error';
            return Promise.reject({
                ...error,
                message: 'A server error occurred. Please try again later.'
            });
        }
        // ✅ 502 error handling
        if (error.response.status === 502) {
            console.error('Bad Gateway / Server Down:', error.response);
            alert('The server is temporarily unavailable (502 Bad Gateway). Please try again later.');
            return Promise.reject({
                ...error,
                message: 'The server is temporarily unavailable. Please try again later.'
            });
        }

        return Promise.reject(error);
    }
);

export { axiosInstance, axiosAnonymousInstance };
// export default axiosAnonymousInstance;

// const baseURL = 'https://theanpr.xyz/';
// const baseURL = 'http://127.0.0.1:8000';
